import { MdEmail } from "react-icons/md";
import loginImg from "../assets/image1.png";
import registerImg from "../assets/image2.png";
import forgotImg from "../assets/image3.png";
import logoImg from "../logo.png";
import "./Login.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillMobile } from "react-icons/ai";
import { FaUser } from "react-icons/fa";
import { BiSolidLockAlt } from "react-icons/bi";
import {
  AdminLogin,
  CreateAccount,
  ForgetPassword,
} from "../apiconfig/authService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { RiLoaderFill } from "react-icons/ri";

const Login = () => {
  const [screen, setScreen] = useState("login");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [ismessageRed, setIsMessageRed] = useState("");
  const [password, setPassword] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validateForm = () => {
    if (firstName === "") throw new Error("First Name is required.");
    if (lastName === "") throw new Error("Last Name is required.");
    if (email === "") throw new Error("Email is required.");
    if (!email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/))
      throw new Error("Invalid email address.");
    if (phoneNumber === "") throw new Error("Phone number is required.");
    if (!phoneNumber.match(/^\d{10}$/))
      throw new Error(
        "Invalid phone number. Please enter a 10-digit phone number."
      );
    if (password === "") throw new Error("Password is required.");
    if (
      !password.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
      )
    )
      throw new Error(
        "Invalid password. It must contain at least one lowercase letter, one uppercase letter, one digit, one special character, and be at least 8 characters long."
      );
  };
  const handleSignUp = async (e) => {
    e.preventDefault();

    try {
      validateForm();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    try {
      response = await CreateAccount({
        firstname: firstName,
        lastname: lastName,
        customerphone: phoneNumber,
        emailid: email,
        password: password,
      });
      if (response.status === 201) {
        setIsMessageRed(false);
        setMessage(response.data.message);
        window.scrollTo(0, 0);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      if (email === "") throw new Error("Email is required.");
      if (password === "") throw new Error("Password is required.");
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }
    try {
      setLoading(true);
      const response = await AdminLogin({ email, password });
      if (response.status === 200) {
        setLoading(false);
        setIsMessageRed(false);
        localStorage.setItem("accessToken", response.data.token);
        navigate("/dashboard");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await ForgetPassword({ email });
      if (response.status === 200) {
        setMessage(response.data.message);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setMessage(err.response.data.error);
      } else {
        setMessage("An error occurred. Please try again later.");
      }
    }
  };


  

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };


  return (
    <div className="LoginPage container-fluid">
      <div className="row bg-light">
        <div className="col-lg-8 p-5" style={{ width: "700" }}>
          <img
            src={
              screen === "login"
                ? loginImg
                : screen === "signup"
                ? registerImg
                : screen === "forgotPassword"
                ? forgotImg
                : ""
            }
            className="loginImg d-block mx-auto img-fluid"
            width="550px"
            alt=" Dummy"
          />
        </div>
        <div className="col-lg-4 bg-white px-5 py-3 d-flex align-items-center">
          <div className="loginCont w-100">
            <div
              className="logo"
              style={{ alignItems: "center", textAlign: "center" }}
            >
              <img
                src={logoImg}
                className="logoImg img-fluid"
                width="50%"
                alt="Logo"
              />
            </div>
            <h3 className="text-success mb-3">
              {screen === "login"
                ? "Welcome to Dashboard"
                : screen === "signup"
                ? "Sign up with Dashboard"
                : screen === "forgotPassword"
                ? "Forgot Password?"
                : ""}
            </h3>
            <p>
              {screen === "login"
                ? "Please sign-in to your account and start the adventure"
                : screen === "signup"
                ? "Make your app management easy and fun!"
                : screen === "forgotPassword"
                ? "Enter your email and we′ll send you instructions to reset your password"
                : ""}
            </p>

            <div
              className={`alert custom-alert ${
                ismessageRed ? "alert-danger" : "alert-primary"
              }`}
              role="alert"
              style={{ visibility: message ? "visible" : "hidden" }}
            >
              {message || "placeholder"}
            </div>

            {screen === "login" ? (
              <form onSubmit={handleLogin} className="LoginForm" action="/">
                <div className="input-group mb-2">
                  <span className="input-group-text" id="basic-addon1">
                    <MdEmail />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="Email"
                    disabled={loading}
                  />
                </div>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <BiSolidLockAlt />
                  </span>

                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control"
                    aria-label="Password"
                    aria-describedby="password-toggle"
                    placeholder="Password"
                    disabled={loading}
                  />
                  <span
                    className="input-group-text"
                    id="password-toggle"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer", fontSize: "1.2rem" }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <div className="row mx-0 my-0 mb-1">
                  <div className="form-check col-lg-6 mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked"
                    >
                      Remember Me
                    </label>
                  </div>
                  <div className="form-check col-lg-6 mb-4 d-flex justify-content-lg-end">
                    <span
                      onClick={() => {
                        setScreen("forgotPassword");
                        setMessage(null);
                        setPassword("");
                      }}
                      className="fw-bold text-primary text-decoration-none"
                      style={{
                        fontSize: "small",
                        textAlign: "center",
                        justify: "center",
                        margin: "auto 1px",
                        cursor: "pointer",
                      }}
                    >
                      Forgot Password?
                    </span>
                  </div>
                </div>
                <div className="buttons mb-4 mx-auto w-50">
                  {loading ? (
                    <button
                      type="button"
                      className="btn btn-primary w-100 d-flex justify-content-center align-items-center"
                      disabled
                    >
                      <RiLoaderFill
                        size={24}
                        className="spin-animation"
                        color="white"
                      />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-success shadow-sm w-100 text-uppercase"
                    >
                      Sign In
                    </button>
                  )}
                </div>

                {/* <div className="regis mb-4 text-center">
                  New on our platform?{" "}
                  <span
                    onClick={() => {
                      setScreen("signup");
                      setPassword("");
                      setMessage(null);
                    }}
                    className="fw-bold text-primary text-decoration-none"
                    style={{ cursor: "pointer" }}
                  >
                    Create an account
                  </span>
                </div> */}
              </form>
            ) : screen === "signup" ? (
              <form onSubmit={handleSignUp} className="LoginForm">
                <div className="input-group mb-2">
                  <span className="input-group-text" id="basic-addon1">
                    <FaUser />
                  </span>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="First Name"
                  />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-text" id="basic-addon1">
                    <FaUser />
                  </span>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="Last Name"
                  />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-text" id="basic-addon1">
                    <MdEmail />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="Email"
                  />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-text" id="basic-addon1">
                    <AiFillMobile />
                  </span>
                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="Mobile No."
                  />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-text" id="basic-addon1">
                    <BiSolidLockAlt />
                  </span>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="Password"
                  />
                </div>
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckChecked"
                  >
                    I agree to &nbsp;{" "}
                    <a
                      href="/"
                      className="fw-bold text-primary text-decoration-none"
                    >
                      privacy policy & terms
                    </a>
                  </label>
                </div>
                <div className="buttons mb-3 mx-auto w-50">
                  <button
                    type="submit"
                    className="btn btn-success shadow-sm text-shadow btn w-100 text-uppercase"
                  >
                    Sign Up
                  </button>
                </div>
                <div className="regis mb-4 text-center">
                  Already have an account?{" "}
                  <span
                    onClick={() => {
                      setScreen("login");
                      setMessage(null);
                      setPassword("");
                      setFirstName("");
                      setLastName("");
                      setPhoneNumber("");
                    }}
                    className="fw-bold text-primary text-decoration-none"
                    style={{ cursor: "pointer" }}
                  >
                    Sign in instead
                  </span>
                </div>
              </form>
            ) : screen === "forgotPassword" ? (
              <form onSubmit={handleForgotPassword} className="LoginForm">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <MdEmail />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="Email"
                  />
                </div>
                <div className="buttons mb-3 mx-auto w-50">
                  <button
                    type="submit"
                    className="btn btn-success shadow-sm btn w-100 text-uppercase"
                  >
                    Send Reset Link
                  </button>
                </div>
                <div className="regis mb-4 text-center">
                  <span
                    onClick={() => {
                      setScreen("login");
                      setMessage(null);
                    }}
                    className="fw-bold text-primary text-decoration-none"
                    style={{ cursor: "pointer" }}
                  >
                    Back to Sign In
                  </span>
                </div>
              </form>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;